export enum NotificationType {
  // community posts
  member_replied_to_post = 'memberrepliedtopost',
  report_reply = 'postreport',
  member_liked_a_post = 'memberlikedapost',
  report_post = 'replyreport',
  new_post_in_my_rooms = 'newpostinmyrooms',
  member_question_in_room = 'memberquestioninroom',
  pin_unpin_post = 'pinunpinpost',
  post_updated = 'postupdated',
  post_inserted = 'postinserted',

  // private rooms
  joinroomrequest = 'joinroomrequest',
  pendingroomrequest = 'pendingroomrequest',
  joinroomrequestanswer = 'joinroomrequestanswer',
  privateroominvite = 'privateroominvite',

  // community comments
  member_replied_to_reply = 'memberrepliedtoreply',
  member_inserted_reply = 'replyinserted',
  member_liked_a_reply = 'memberlikedareply',

  // polls
  poll_closed = 'surveyclosed',
  poll_report = 'surveyreport',
  member_responded_poll = 'memberrespondedsurvey',
  member_published_poll = 'memberpublishedsurvey',
  moderator_deleted_poll = 'moderatordeletedsurvey',

  //stories:
  story_report = 'storyreport',
  memberlikedastory = 'memberlikedastory',
  memberlikedastorycomment = 'memberlikedastorycomment',
  memberpublishedstory = 'memberpublishedstory',
  memberpublishedstorytoroom = 'memberpublishedstorytoroom',
  someonefollowsmeonstory = 'someonefollowsmeonstory',

  // story comments
  story_comment_report = 'storycommentreport',
  membercommentedtostory = 'membercommentedtostory',
  membercommentedtostorycomment = 'membercommentedtostorycomment',

  // journey
  journey_reminder = 'journeyreminder',

  //moderator:
  moderatordeletedstory = 'moderatordeletedstory',
  moderatordeletedcomment = 'moderatordeletedcomment',
  moderatordeletedpost = 'moderatordeletedpost',
  moderatormemberblock = 'moderatormemberblock',
  moderatoreditedpost = 'moderatormoderatedpost',
  moderatoreditedreply = 'moderatormoderatedreply',
  moderatoreditedstory = 'moderatormoderatedstory',
  moderatoreditedcomment = 'moderatormoderatedcomment',

  // social
  referral_invite_accepted = 'referralinviteaccepted',
  companion_request = 'companionrequest',
  companion_remove = 'companionremove',
  chat_message = 'chatmessage',
  companion_request_answer = 'companionrequestanswer',
  pending_companion_request = 'pendingcompanionrequest',

  // others
  system_message = 'systemmessage',
  carepoint = 'carepoint',
  moodtracker_reminder = 'moodtrackerreminder',

  //banner
  banner = 'banner',

  videoprocessedsuccessfully = 'videoprocessedsuccessfully',
  videoprocessederrored = 'videoprocessederrored',
}
